'use client';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn(
			'peer h-4 w-4 shrink-0 rounded-sm ring-[1px]  ring-primary/90 ring-offset-white data-[state=checked]:bg-slate-900 data-[state=checked]:text-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50  dark:border-slate-800 dark:ring-offset-slate-950 dark:data-[state=checked]:bg-slate-50 dark:data-[state=checked]:text-slate-900 dark:focus-visible:ring-slate-300',
			className,
		)}
		{...props}
	>
		<CheckboxPrimitive.Indicator
			className={cn(
				'text-current, justify-center, flex items-center rounded-sm bg-primary',
			)}
		>
			<Check className="h-4 w-4" />
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
